export default __webpack_public_path__ + "static/media/sandal14.2dff1c99.jpeg";